
import { ErrorHandler, Injectable } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { PractitionerGroupStateModel, PractitionerGroupEntity, ChatStateModel, TeamMember } from "huddyapi";
import { Select } from "@ngxs/store";



@Injectable()
export class CommunityConfigService {

  static isCommunity: boolean = false;
  static userTeams: UserTeam[] = [];
  static fullTeams : PractitionerGroupEntity[] = [];
  public static teamsLoaded = false;
  static allMembers : TeamMember[] = [];
  private static currentTeam: UserTeam;
  static chatState : ChatStateModel;
  static currentTeamSubject: BehaviorSubject<UserTeam> = new BehaviorSubject<UserTeam>(undefined);

  static setCurrentTeam(team: UserTeam) {
    CommunityConfigService.currentTeam = team;
    console.log('Setting current team', team);
    this.currentTeamSubject.next(team);
  }

  static hasRole(teamRole : string) : boolean {
    return (!CommunityConfigService.isCommunity || !CommunityConfigService.currentTeam || (CommunityConfigService.currentTeam && CommunityConfigService.currentTeam.teamRole === teamRole));
  }

  static hasCurrentTeam(): boolean {
    return CommunityConfigService.currentTeam != undefined && CommunityConfigService.currentTeam != null;
  }
  @Select(state => state.practitionerGroupState) static practitionerGroupState$;
  static practitionerGroupSubscription : Subscription; 
  static init() {
    CommunityConfigService.practitionerGroupSubscription  = CommunityConfigService.practitionerGroupState$.subscribe((practitionerGroupState: PractitionerGroupStateModel) => {
      console.log(practitionerGroupState);
      if (practitionerGroupState && practitionerGroupState.userTeams  && practitionerGroupState.userTeams.length > 0 && !CommunityConfigService.teamsLoaded) {
        CommunityConfigService.teamsLoaded = true;
        CommunityConfigService.fullTeams = practitionerGroupState.userTeams;
        CommunityConfigService  .userTeams = practitionerGroupState.userTeams
        .filter(pg =>  pg.teamRole != null)
        .map(pg => ({
            teamId : pg.id,
            teamName : pg.name,
            teamRole : pg.teamRole,
            evaluatorTeam: pg.groupUsers.filter(gu => gu.role === 'EVALUATOR').length > 0
          }));
          let teamRoles : string[] = CommunityConfigService.userTeams.map(t => t.teamRole);
          for (let pg of CommunityConfigService.fullTeams) {
            CommunityConfigService.allMembers = CommunityConfigService.allMembers.concat(pg.teamMembers);
          }
          let maxRole : string = 'SCHEDULER';
          if (teamRoles.includes('COORDINATOR')) {
            maxRole = 'COORDINATOR';
          }
          if (teamRoles.includes('PROJECT_LEAD')) {
            maxRole = 'PROJECT_LEAD';
          }
          
      
          let allTeam : UserTeam = {
            teamId: -1,
            teamName: 'All teams',
            teamRole: maxRole
          };
          //TODO: UNCOMMENT WHEN FIXED
           CommunityConfigService.userTeams.push(allTeam);
          CommunityConfigService.userTeams = CommunityConfigService.userTeams.sort((a, b) => a.teamName.localeCompare(b.teamName));
          //CommunityConfigService.setCurrentTeam(CommunityConfigService.userTeams[0]);
          CommunityConfigService.setCurrentTeam(allTeam);
          console.log('userteams', practitionerGroupState.userTeams, CommunityConfigService.userTeams);
      }
     
    });;
  }

  public static isEvaluationTeam() : boolean {
    return CommunityConfigService.currentTeam.evaluatorTeam;
  }


 



}

export interface UserTeam {
  teamId: number;
  teamName: string;
  teamRole: string;
  evaluatorTeam? : boolean;
}